import { Menu as AntdMenu } from "antd";
import { useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import { getRoutes, ROUTE_GROUPS } from "../../../../routes/Routes";

const Menu = ({ onMenuClick }) => {
    const location = useLocation();

    const { user } = useSelector((state) => state.authSlice);

    const routes = getRoutes();

    const allEntries = Object.entries(routes);

    const canAccess = (route) =>
        !route.allowedRoles || route.allowedRoles.includes(user?.role);

    const flatItems = allEntries
        .filter(([, route]) => route?.icon && !route.group && canAccess(route))
        .map(([, route]) => ({
            key: route.path,
            icon: route.icon,
            label: <Link onClick={onMenuClick} to={route.path}>{route.name}</Link>,
            menuOrder: route.menuOrder ?? 0,
        }));

    const groupedItems = Object.entries(ROUTE_GROUPS || {})
        .map(([groupKey, groupConfig]) => {
            const children = allEntries
                .filter(([, route]) => route.group === groupKey && canAccess(route))
                .map(([, route]) => ({
                    key: route.path,
                    icon: route.icon,
                    label: <Link onClick={onMenuClick} to={route.path}>{route.name}</Link>,
                }));

            if (children.length === 0) return null;

            return {
                key: `${groupKey}-group`,
                icon: groupConfig.icon,
                label: groupConfig.name,
                children,
                menuOrder: groupConfig.menuOrder ?? 0,
            };
        })
        .filter(Boolean);

    // Sort flat and grouped items together by menuOrder
    const menuItems = [...flatItems, ...groupedItems]
        .sort((a, b) => a.menuOrder - b.menuOrder)
        .map(({ menuOrder: _, ...item }) => item);

    const activePage = '/' + (location?.pathname?.split('/')[1] || '');

    return (
        <AntdMenu
            mode="inline"
            selectedKeys={[activePage]}
            theme="light"
            style={{ minHeight: '100%', borderRight: 'none' }}
            items={menuItems}
        />
    );
};

export default Menu;